import { type ReactNode } from 'react'

type FormGroupProps = {
  label?: string
  error?: string
  children: ReactNode
}

export const FormGroup = ({ label, error, children }: FormGroupProps) => {
  return (
    <label>
      <span className="relative block mb-1 text-xs text-grey-800 lg:mb-3 lg:text-sm">
        {label}
      </span>
      {children}
      {error && <p className="mt-2 text-[#FF4949] text-xs">{error}</p>}
    </label>
  )
}
